class PepToggleController extends Stimulus.Controller {
  static values = { shown: Boolean };
  static targets = ['container'];

  shownValueChanged(shown) {
    if (shown) {
      this.#showContainer();
    } else {
      this.#hideContainer();
    }
  }

  toggle(event) {
    this.shownValue = (event.target.value === 'true');
  }

  #showContainer() {
    this.containerTarget.classList.remove('d-none');
    this.containerTarget.querySelectorAll('input, select').forEach(field => {
      field.disabled = false;
    });
  }

  #hideContainer() {
    this.containerTarget.classList.add('d-none');
    this.containerTarget.querySelectorAll('input[type=text], input[type=date]').forEach(input => {
      input.value = '';
      input.disabled = true;
    });
    this.containerTarget.querySelectorAll('select').forEach(select => {
      select.value = '';
      select.disabled = true;
    });
    this.containerTarget.querySelectorAll('input[type=radio]').forEach(radio => {
      radio.checked = false;
      radio.disabled = true;
    });
  }
}
